/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const CancellationStatus = {
  Pending: "pending",
  Completed: "completed",
  Failed: "failed",
} as const;
export type CancellationStatus = ClosedEnum<typeof CancellationStatus>;

/** @internal */
export const CancellationStatus$inboundSchema: z.ZodNativeEnum<
  typeof CancellationStatus
> = z.nativeEnum(CancellationStatus);
/** @internal */
export const CancellationStatus$outboundSchema: z.ZodNativeEnum<
  typeof CancellationStatus
> = CancellationStatus$inboundSchema;
